module.exports = __webpack_public_path__ + "img/phone.fcc58aa8.svg";